// src/pages/EditBatch.js
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import BatchForm from "../components/BatchForm";
import { convertToInputDateFormat } from "../utils/dateUtils"; 

const API_BASE_URL = "https://nzpdp-traceability-system-production-c63a.up.railway.app";

const EditBatch = () => {
  const { batchNo } = useParams();  
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [batchData, setBatchData] = useState(null);

  useEffect(() => {
    axios.get(`${API_BASE_URL}/api/admin/batches/${batchNo}`)
      .then((response) => {
        const batch = response.data;
        setBatchData({
          ...batch,
          manufacture_date: convertToInputDateFormat(batch.manufacture_date), // 确保 input 使用 YYYY-MM-DD
          expiry_date: convertToInputDateFormat(batch.expiry_date),
        });
      })
      .catch((error) => {
        console.error("Error fetching batch:", error.response ? error.response.data : error.message);
      });

    axios.get(`${API_BASE_URL}/api/admin/products`)
      .then((response) => {
        setProducts(response.data);
      })
      .catch((error) => {
        console.error("Error fetching products:", error.response ? error.response.data : error.message);
      });

  }, [batchNo]);

  const handleSubmit = (event, updatedBatchData) => {
    event.preventDefault();
  
    axios
      .put(`${API_BASE_URL}/api/admin/edit-batch/${batchNo}`, updatedBatchData)
      .then(() => {
        alert("Batch updated successfully!");
        navigate(`/admin/edit-batch/${batchNo}`);
      })
      .catch((error) => {
        if (error.response) {
          
          if (error.response.status === 400 && error.response.data.error === "Batch No already exists") {
            alert("Error: The batch number already exists. Please choose a different batch number.");
          } else {
            alert(`Error updating batch: ${error.response.data.error || "Unknown error"}`);
          }
        } else {
          alert("Error updating batch: Network issue or server unavailable.");
        }
      });
  };
  
  if (!batchData) return <p>Loading...</p>;

  return (
    <div>
      <h3>Edit Batch</h3>
      <BatchForm initialData={batchData} products={products} onSubmit={handleSubmit} />
    </div>
  );
};

export default EditBatch;
